import React from "react";
import { FaBook, FaMusic, FaBus, FaMicroscope, FaLaptop, FaLightbulb } from "react-icons/fa";
import "./Facilities.css";

const Facilities = () => {
  const facilities = [
    {
      icon: <FaBook size={40} color="#901b1b" />,
      title: "Library",
      description:
        "Our library houses thousands of books across various disciplines. Students can access digital and physical resources. Regular book fairs are held to cultivate a love for reading.",
    },
    {
      icon: <FaLightbulb size={40} color="#901b1b" />,
      title: "Smart Digital Class",
      description:
        "Smart classrooms enhance learning with multimedia tools. Students enjoy interactive sessions with modern teaching methods.",
    },
    {
      icon: <FaBus size={40} color="#901b1b" />,
      title: "School Bus",
      description:
        "A fleet of GPS-enabled buses ensures safe and convenient transportation for students across various locations.",
    },
    {
      icon: <FaLaptop size={40} color="#901b1b" />,
      title: "Computer Lab",
      description:
        "Advanced computer labs foster creativity and innovation. Students learn tech skills.",
    },
    {
      icon: <FaMicroscope size={40} color="#901b1b" />,
      title: "Science Lab",
      description:
        "Science labs encourage hands-on learning in physics, chemistry, and biology. Students explore concepts practically.",
    },
    {
      icon: <FaMusic size={40} color="#901b1b" />,
      title: "Playground",
      description:
        "The playground is a fun and safe space where students can play, explore, and spend time with their friends during breaks.",
    },
  ];

  return (
    <div className="facilities-container">
      <h2 className="facilities-heading">SCHOOL FACILITIES</h2>
      <div className="facilities-grid">
        {facilities.map((facility, index) => (
          <div className="facility-card" key={index}>
            {facility.icon}
            <h3>{facility.title}</h3>
            <p>{facility.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Facilities;
